<div class="app-page" fxFill>
<mat-toolbar style="background-color: var(--mat-sys-background); color: var(--mat-sys-on-background);">
    <button mat-icon-button (click)="back()">
      <mat-icon>
        arrow_back_ios_new
      </mat-icon>
    </button>
     <label>
      {{"CONFIG.SCOUTEDIT" | translate | uppercase}}
    </label>
  </mat-toolbar>
  <div class="config-user-content">
    @if (user(); as currentUser) {
      <form>
        <input type="hidden" [formField]="controlField('Email')">
        <input type="hidden" placeholder="Username" [formField]="controlField('UserName')">
        <label style="font-family: Roboto; font-size: small; color: rgba(255, 255, 255, 0.7)" >{{"GENERAL.USERNAME" | translate }}</label><br/>
        <label style="font-family: Roboto;" >{{currentUser.UserName}}</label>
        <br/>
        <br/>
        <mat-form-field style="width: 350px;">
            <mat-label>
            {{ 'GENERAL.FIRSTNAME' | translate }}
            <span class="required-marker">*</span>
          </mat-label>
          <input matInput  [formField]="controlField('FirstName')">
          
        </mat-form-field>
        <br/>
        <mat-form-field style="width: 350px;">
          <mat-label>
            {{ 'GENERAL.LASTNAME' | translate }}
            <span class="required-marker">*</span>
          </mat-label>
          <input matInput  [formField]="controlField('LastName')">
         
        </mat-form-field><br/>
        <mat-form-field>
          <mat-label>{{'GENERAL.COLOR' | translate }}</mat-label>
          <mat-select [formField]="controlField('UserBgColor')">
            <mat-option value="#FF6633">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #FF6633; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Orange
              </div>
            </mat-option>
            <mat-option value="#FFB399">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #FFB399; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Light orange
              </div>
            </mat-option>
            <mat-option value="#FF33FF">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #FF33FF; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Magenta
              </div>
            </mat-option>
            <mat-option value="#00B3E6">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #00B3E6; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Cyan
              </div>
            </mat-option>
            <mat-option value="#E6B333">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #E6B333; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Gold
              </div>
            </mat-option>
            <mat-option value="#3366E6">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #3366E6; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Blue
              </div>
            </mat-option>
            <mat-option value="#999966">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #999966; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Olive
              </div>
            </mat-option>
            <mat-option value="#99FF99">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #99FF99; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Light green
              </div>
            </mat-option>
            <mat-option value="#B34D4D">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #B34D4D; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Red
              </div>
            </mat-option>
            <mat-option value="#80B300">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #80B300; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Yellow green
              </div>
            </mat-option>
            <mat-option value="#809900">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #809900; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Yellow
              </div>
            </mat-option>
            <mat-option value="#E6B3B3">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #E6B3B3; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Light red
              </div>
            </mat-option>
            <mat-option value="#6680B3">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #6680B3; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Light blue
              </div>
            </mat-option>
            <mat-option value="#66991A">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #66991A; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Olive green
              </div>
            </mat-option>
            <mat-option value="#FF99E6">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #FF99E6; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Light magenta
              </div>
            </mat-option>
            <mat-option value="#CCFF1A">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #CCFF1A; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Light yellow
              </div>
            </mat-option>
            <mat-option value="#FF1A66">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #FF1A66; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Light pink
              </div>
            </mat-option>
            <mat-option value="#E6331A">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #E6331A; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Dark red
              </div>
            </mat-option>
            <mat-option value="#33FFCC">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #33FFCC; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Light teal
              </div>
            </mat-option>
            <mat-option value="#66994D">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #66994D; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Dark olive green
              </div>
            </mat-option>
            <mat-option value="#B366CC">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #B366CC; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Light purple
              </div>
            </mat-option>
            <mat-option value="#4D8000">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #4D8000; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Dark green
              </div>
            </mat-option>
            <mat-option value="#B33300">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #B33300; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Dark orange
              </div>
            </mat-option>
            <mat-option value="#CC80CC">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #CC80CC; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Light pink
              </div>
            </mat-option>
            <mat-option value="#66664D">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #66664D; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Dark gray
              </div>
            </mat-option>
            <mat-option value="#991AFF">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #991AFF; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Dark violet
              </div>
            </mat-option>
            <mat-option value="#E666FF">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #E666FF; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Light violet
              </div>
            </mat-option>
            <mat-option value="#4DB3FF">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #4DB3FF; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Light blue
              </div>
            </mat-option>
            <mat-option value="#1AB399">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #1AB399; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Dark cyan
              </div>
            </mat-option>
            <mat-option value="#E666B3">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #E666B3; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Light magenta
              </div>
            </mat-option>
            <mat-option value="#33991A">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #33991A; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Dark green
              </div>
            </mat-option>
            <mat-option value="#CC9999">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #CC9999; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Light gray
              </div>
            </mat-option>
            <mat-option value="#B3B31A">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #B3B31A; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Olive green
              </div>
            </mat-option>
            <mat-option value="#00E680">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #00E680; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Bright teal
              </div>
            </mat-option>
            <mat-option value="#4D8066">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #4D8066; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Dark teal
              </div>
            </mat-option>
            <mat-option value="#809980">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #809980; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Sage green
              </div>
            </mat-option>
            <mat-option value="#E6FF80">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #E6FF80; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Light green
              </div>
            </mat-option>
            <mat-option value="#1AFF33">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #1AFF33; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Bright green
              </div>
            </mat-option>
            <mat-option value="#999933">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #999933; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Olive drab
              </div>
            </mat-option>
            <mat-option value="#FF3380">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #FF3380; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Light coral
              </div>
            </mat-option>
            <mat-option value="#CCCC00">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #CCCC00; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Yellow
              </div>
            </mat-option>
            <mat-option value="#66E64D">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #66E64D; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Light green
              </div>
            </mat-option>
            <mat-option value="#4D80CC">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #4D80CC; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Dark blue
              </div>
            </mat-option>
            <mat-option value="#9900B3">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #9900B3; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Dark magenta
              </div>
            </mat-option>
            <mat-option value="#E64D66">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #E64D66; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Light red
              </div>
            </mat-option>
            <mat-option value="#4DB380">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #4DB380; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Medium teal
              </div>
            </mat-option>
            <mat-option value="#FF4D4D">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #FF4D4D; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Light red
              </div>
            </mat-option>
            <mat-option value="#99E6E6">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #99E6E6; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Light cyan
              </div>
            </mat-option>
            <mat-option value="#6666FF">
              <div style="display: flex; flex-direction: row;">
                <div style="background-color: #6666FF; width: 20px; border-radius: 10px; height: 20px; margin-right: 5px;"></div>
                Medium blue
              </div>
            </mat-option>
          </mat-select>
        </mat-form-field>
        <!--   <mat-checkbox formControlName="AllTeams">All teams</mat-checkbox>
        <br/>
        <mat-checkbox formControlName="AllSeasons">All seasons</mat-checkbox> -->
        <br>
          <mat-checkbox id="WebCalendarEnabled"
          [formField]="controlField('WebCalendarEnabled')">Web calendar</mat-checkbox>
          @if (currentUser.ConnectedPlayer) {
            <div>
              <h2 style="font-family: Roboto;">
                Connected player
              </h2>
              <div style="font-family: Roboto;">
                User is connected to this player in database
              </div>
              <div>
                <table>
                  <tr>
                    <td>
                    </td>
                    <td>
                      <a [routerLink]="['/player/details', currentUser.ConnectedPlayer.PlayerId]" style="color: White; font-size: large;">
                        {{currentUser.ConnectedPlayer.LastName}}, {{currentUser.ConnectedPlayer.FirstName}}
                      </a>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          }
          @if (!currentUser.ConnectedPlayer) {
            <div class="scout-admin-sections">
              <div class="scouting-roles-wrap" >
                <h2 style="font-family: Roboto;">
                  Scouting - Roles
                </h2>
                <div class="scouting-roles-content">
                  <div style="font-family: Roboto;">
                    Changes in roles require the user to login again before they are active.
                  </div>
                  <br/>
                  @for (control of scoutingRoleControls; track control.field) {
                    <div>
                      <mat-checkbox [id]="control.field" [formField]="controlField(control.field)">{{control.label}}</mat-checkbox>
                      <br/>
                    </div>
                  }
                </div>
              </div>
              <div class="scout-access-wrap">
                <h2 style="font-family: Roboto;">
                  Scout Artifact Access
                </h2>
                <div class="roledescription">
                  Select which other scouts this user can access notes, reports, grades, and statistics for.
                </div>

                @if ((userModel().UserSecurity ?? []).length > 0) {
                  <div class="scout-access-table-wrap">
                    <table class="scout-access-table">
                      <thead>
                        <tr>
                          <th>Scout</th>
                          @for (control of userSecurityControls; track control.field) {
                            <th>{{control.label}}</th>
                          }
                        </tr>
                      </thead>
                      <tbody>
                        @for (security of (userModel().UserSecurity ?? []); track security.UserId; let i = $index) {
                          <tr>
                            <td>{{security.Value}}</td>
                            @for (control of userSecurityControls; track control.field) {
                              <td>
                                <mat-checkbox
                                  [id]="'user-security-' + i + '-' + control.field"
                                  [checked]="isUserSecurityChecked(i, control.field)"
                                  (change)="onUserSecurityChanged(i, control.field, $event.checked)">
                                </mat-checkbox>
                              </td>
                            }
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                }
                @if ((userModel().UserSecurity ?? []).length == 0) {
                  <div class="roledescription">
                    No scout access entries were returned from backend.
                  </div>
                }
              </div>
<!--               <div style="max-width: 390px;">
                <h2 style="font-family: Roboto;">
                  Roles
                </h2>
                <div style="margin-left: 20px;">
                  <label class="roledescription">A role gives the user rights to perform actions on specific data object.</label>
                  <div  class="roledescription">
                    Changes in roles require the user to login again before they are active.
                  </div>
                  <br/>
                  @for (control of roleControls; track control.field) {
                    <div>
                      <mat-checkbox [id]="control.field" [formField]="controlField(control.field)">{{control.label}}</mat-checkbox>
                      <br/>
                      <br/>
                    </div>
                  }
                  <br/>
                  <div  class="roledescription">
                    Allow user to access injury information
                  </div>
                  <br/>
                  <div  class="roledescription">
                    Allow user to view player grades
                  </div>
                  <div  class="roledescription">
                    Allow user to view player status and load
                  </div>
                  <div  class="roledescription">
                    Allow user to view or edit player contact information
                  </div>
                  <label class="roledescription">Enables user to create training programs, workouts, exercises</label>
                  <label class="roledescription">Enables user to create new forms and delete any submitted form</label>
                  <label class="roledescription">Enables user to see submitted forms</label>
                  <label class="roledescription">Enables user to submit forms</label>
                  <label class="roledescription">Enables user to create edit user information</label>
                </div>
              </div> -->
<!--               <div >
                <h2 style="font-family: Roboto;">
                  Team access
                </h2>
                <div  class="roledescription">
                  Assing what data the user can see in each team. <br/>
                </div>
                <div>
                  <div  STYLE="display: flex; flex-direction: row;">
                    <div style="width: 200px; font-family: Roboto;" >
                    </div>
                    <div  style="width: 100px;font-family: Roboto;">
                      Grades
                    </div>
                    <div style="width: 100px;font-family: Roboto;">
                      Status
                    </div>
                    <div style="width: 100px;font-family: Roboto;">
                      Load
                    </div>
                    <div style="width: 100px;font-family: Roboto;">
                      Test
                    </div>
                    <div style="width: 100px;font-family: Roboto;">
                      Injury
                    </div>
                    <div style="width: 100px;font-family: Roboto;">
                      Objective
                    </div>
                    <div style="width: 100px;font-family: Roboto;">
                      Contacts
                    </div>
                    <!--     <div style="width: 100px;font-family: Roboto;">
                    Training
                  </div> -->
              <!--     <div style="width: 100px;font-family: Roboto;">
                    Forms
                  </div>
                </div> -->
                <!--   @for (team of userForm.LoadAccessRights; track team; let i = $index) {
                    <div>
                      <div STYLE="display: flex; flex-direction: row; border-bottom: gray solid 1px;">
                        <div style="width: 200px; font-family: Roboto; font-weight: bold;" >
                          {{team().value().Value}}<br/>
                        </div>
                        @for (control of teamAccessControls; track control.field) {
                          <div style="width: 100px;">
                            <mat-checkbox [id]="control.field + '-' + i" [formField]="rowField(team, control.field)"></mat-checkbox>
                          </div>
                        }
                      </div>
                    </div>
                  } 
            </div> 
          </div>-->
        </div>
      }
      <br/>
      <button  mat-raised-button color="primary" type="button" (click)="saveUser();" [disabled]="!canSaveUser()">SAVE</button>
      &nbsp;
      <button  mat-button  (click)="cancel();">CANCEL</button>
    </form>
  }

</div>

</div>